<template>
    <div class="traveler-component">
        <div class="title">
            {{ $t('f_passanger_title') }} {{ index + 1 }}
            <span class="remove icon icon-cross" @click="removeTraveler(traveler.id)" />
        </div>
        <div class="own-input is_adult">
            <label :for="`traveler_child_${index}`" class="checkbox-container">
                {{ $t('f_under_18_label') }}
                <input
                    :id="`traveler_child_${index}`"
                    v-model="traveler.is_adult"
                    type="checkbox">
                <span class="checkmark" />
            </label>
        </div>
        <div class="own-input">
            <label :for="`traveler_name_${index}`">{{ $t('f_name_label') }}</label>
            <input
                :id="`traveler_name_${index}`"
                v-model="traveler.name"
                v-validate="'required'"
                v-m-android-focus
                :name="`travelers[${index}][name]`"
                :placeholder="$t('f_name_placeholder')"
                type="text">
            <span v-if="errors.first(`travelers[${index}][name]`)" class="error-message">
                {{ errors.first(`travelers[${index}][name]`) }}
            </span>
        </div>
        <div v-if="!traveler.is_adult" class="own-input">
            <label :for="`traveler_email_${index}`">{{ $t('f_email_label') }}</label>
            <input
                :id="`traveler_email_${index}`"
                v-model="traveler.email"
                v-validate="'email'"
                v-m-android-focus
                :name="`travelers[${index}][email]`"
                placeholder="your@email.com"
                type="email">
            <span v-if="errors.first(`travelers[${index}][email]`)" class="error-message">
                {{ errors.first(`travelers[${index}][email]`) }}
            </span>
        </div>
        <div v-if="traveler.is_adult">
            <div class="own-input">
                <label :for="`traveler_pname_${index}`">{{ $t('f_name_of_parent_label') }}</label>
                <input
                    :id="`traveler_pname_${index}`"
                    v-model="traveler.parent_name"
                    v-validate="'required'"
                    v-m-android-focus
                    :name="`travelers[${index}][parent_name]`"
                    :placeholder="$t('f_name_placeholder')"
                    type="text">
                <span v-if="errors.first(`travelers[${index}][parent_name]`)" class="error-message">
                    {{ errors.first(`travelers[${index}][parent_name]`) }}
                </span>
            </div>
            <div class="own-input">
                <label :for="`traveler_pemail_${index}`">{{ $t('f_email_of_parent_label') }}</label>
                <input
                    :id="`traveler_pemail_${index}`"
                    v-model="traveler.parent_email"
                    v-validate="'email'"
                    v-m-android-focus
                    :name="`travelers[${index}][parent_email]`"
                    placeholder="your@email.com"
                    type="email">
                <span v-if="errors.first(`travelers[${index}][parent_email]`)" class="error-message">
                    {{ errors.first(`travelers[${index}][parent_email]`) }}
                </span>
            </div>
        </div>
    </div>
</template>
  
  <script>
    export default {
      inject: ['$validator'],
      props: ['index', 'traveler'],
      methods: {
        removeTraveler: function(id) {
          this.$validator.pause()
          this.$store.commit('travelers/REMOVE', id)
          this.$nextTick(() => this.$validator.resume())
        }
      }
    }
  </script>
  
  <style lang="scss">
    @import '~@stylesheets/_vars.scss';
  
    .traveler-component {
      .title {
        background-color: $light_gray_c;
        font-size: 18px !important;
        text-align: left;
        position: relative;
        padding: 12px 0;
        border: 1px solid $light_gray_a;
        .content {
          bottom: 43px;
        }
      }
  
      .is_adult {
        label {
          font-size: 15px;
          padding-top: 2px;
        }
  
        .checkmark {
          height: 22px;
          width: 22px;
  
          &:after {
            top: 3px;
            left: 7px;
          }
        }
      }
    }
  </style>
  